import InfoIcon from '@mui/icons-material/Info';
import { Typography, Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

FormTitle.propTypes = {
    title: PropTypes.string,
    tooltipText: PropTypes.string,
    required: PropTypes.bool,
};

export default function FormTitle({ title, required, tooltipText }) {
    const words = title?.split(' ');
    const lastWord = words?.pop();

    return (
        <Box sx={{ lineHeight: 1 }}>
            <Typography variant={'subtitle2'} color="text.secondary">
                {words?.join(' ')}{' '}
                <Box sx={{ display: 'inline-flex' }}>
                    {lastWord}
                    {tooltipText && (
                        <Tooltip placement="top" arrow title={tooltipText} sx={{ fontSize: '1rem' }}>
                            <InfoIcon color="secondary" fontSize="small" />
                        </Tooltip>
                    )}
                </Box>
                {required && (
                    <Box component="span" sx={{ color: 'error.main', ml: '2px' }}>
                        *
                    </Box>
                )}
            </Typography>
        </Box>
    )
}
